import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/helpers/h";

function _normalizeRows(payload) {
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data)) return payload.data;
  return payload?.data ?? payload;
}

export function useApiPaginatedList(resourcePath, deps = []) {
  const depsKey = JSON.stringify(deps);
  const queryKey = useMemo(
    () => ["apiPaginatedList", resourcePath, depsKey],
    [resourcePath, depsKey],
  );

  const queryFn = async () => {
    const res = await fetchApi({
      url: resourcePath,
      method: "GET",
    });
    if (res?.data?.success) {
      return res.data;
    }
    return { data: { data: [] }, meta: { current_page: 1, last_page: 1 } };
  };

  const {
    data: rawData,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey,
    queryFn,
    enabled: !!resourcePath,
  });

  return {
    data: rawData,
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
}
